import React from 'react';

const ResultsCount = ({ count, title }) => {
  return (
    <span className="p-2">{count} {title}</span>
  );
};

export default ResultsCount;
